import { getStoryBySlug } from '@cinch-nx/data-storyblok'
import { InferGetStaticPropsType } from 'next'

import { SupportPageStoryContent } from '../types/support-page'
import { setTag, tagError, traceFunction } from '@core/datadog-server'

async function getStaticPropsfn({ preview = false }) {
  try {
    const story = await getStoryBySlug<SupportPageStoryContent>('support', {
      version: preview ? 'draft' : 'published',
    })

    const HeroProps = story?.content?.hero?.[0]

    setTag('response.code', 200)
    setTag('page.name', 'support')
    setTag('page.rendered', 'ISR')
    setTag('page.revalidate-in', '300s')
    setTag(
      'page.params',
      JSON.stringify(
        {
          preview,
        },
        null,
        2,
      ),
    )

    return {
      props: {
        story,
        preview,
        generatedAt: Date.now(),
        layoutProps: {
          heroProps: HeroProps,
          showBorderRadius: true,
        },
      },
      revalidate: 300, // In seconds
    }
  } catch (error) {
    if (typeof error === 'string' || error instanceof Error) {
      tagError(error)
    }

    return {
      props: {
        story: null,
        preview,
        generatedAt: Date.now(),
        layoutProps: {
          heroProps: [],
          showBorderRadius: true,
        },
      },
      revalidate: 300, // In seconds
    }
  }
}

export const getStaticProps = traceFunction(
  'support.getStaticProps',
  getStaticPropsfn,
)
export type SupportPageProps = InferGetStaticPropsType<typeof getStaticProps>
